import { Component, OnInit, ChangeDetectorRef, AfterContentChecked, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { CountryNames, UpdateDecisionTable, DecisionTypes, DecisionTable, DecisionParameters, DecisionRules } from 'src/app/interfaces/apiresponses';
import { RestService } from 'src/app/services/rest/rest.service';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

@Component({
  selector: 'app-decision-table',
  templateUrl: './decision-table.component.html',
  styleUrls: ['./decision-table.component.scss'],
  providers: [DatePipe]
})
export class DecisionTableComponent {

  selectedCountryNames: string[] = [];
  selectedItem: any
  decisionSaveModel: boolean = false
    columns = [
    // {
    //   key: 'id',
    //   label: 'ID',
    //   _cellProps: { align: 'middle' },
    //   filter: true
    // },

    {
      key: 'paramerID',
      label: 'Parameter',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'decisionRule',
      label: 'Decision Rule',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'decisionType',
      label: 'Decision Type',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'decisionValue',
      label: 'Decision Value',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'allowOnboarding',
      label: 'Allow Onboarding',
      _cellProps: { align: 'middle' },
      filter: true
    }
  ];
  countryList: CountryNames | undefined
  decisionTable: any = []
  selectedItems = [2, 3];
  DecisionParameters: any = []
  DecisionParametersSources: any = []
  DecisionRules: any = []
  DecisionTypes: any = []
  getRowValueData: any;
  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef) {
    this.getDecisionParameters()
  }
  decisionTableForm!: FormGroup
  ngOnInit() {

  }
  
  countryFullValue:any[]= []
  OnCountryList(event: any) {
    if (event.success)
    {
      this.countryList = event.data
      this.countryFullValue = event?.data?.dhabiCountries
      
    }
    else {
      this.showAlertBox('Sorry', 'Something wrong with the remote system. Please contact the support')
    }
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  // Search Form
  searchCompanyName: string = ''
  searchTrandeLicense: string = ''
  dcecisionValue:any = []
  selectValue:boolean =false;
  rowSelected(event: any) {

    console.log(event);

    this.countryList?.dhabiCountries.length
    this.decisionSaveModel = true;
    this.getRowValueData = event?.item
    if(this.getRowValueData?.decisionValue != undefined){
      this.getRowValueData.countryFull
      if(this.getRowValueData?.paramerID != 'Income'){
        this.getDecisionTable()
        this.selectValue =  true 
         let  bSplitValue = this.getRowValueData?.splitValue.split(',').map(function(item:any) {
          return parseInt(item, 10);
      });
         this.dcecisionValue = bSplitValue 
     }
     else{
       this.selectValue =  false
        this.dcecisionValue = this.getRowValueData?.decisionValue
     }
    }
    this.decisionTableForm = new FormGroup({
      paramerID: new FormControl(this.getRowValueData?.paramerID , [Validators.required]),
      decisionRule: new FormControl(this.getRowValueData?.decisionRule, [Validators.required]),
      decisionType: new FormControl(this.getRowValueData?.decisionType, [Validators.required]),
      decisionValue: new FormControl<string[]>(this.dcecisionValue, [Validators.required]),
      allowOnboarding: new FormControl(this.getRowValueData?.allowOnboarding, [Validators.required]),
    })
    
  }
  getLeadDate(item: any) {
    return this.datePipe.transform(item.requestedOn, "dd-MM-yyyy")
  }
    getDecisionParameters() {
    this.restApi.getDecisionParameters().subscribe({
      next: (v: DecisionParameters) => {
        if (v.success) {
          this.DecisionParametersSources = v.parameters[0].sources;
          this.DecisionParameters = v.parameters.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })
          console.log(this.DecisionParametersSources)
          //this.loadCountryNames()
          this.getDecisionDataTypes()
        }
      },
      error: (e) => {

      }
    })
  }
  getDecisionRules() {
    this.restApi.getDecisionRules().subscribe({
      next: (v: DecisionRules) => {
        if (v.success) {
          this.DecisionRules = v.rules
          this.DecisionRules = v.rules.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })
          this.getDecisionTable()

        }
      },
      error: (e) => {

      }
    })
  }
  getDecisionDataTypes() {
    this.restApi.getDecisionDataTypes().subscribe({
      next: (v: DecisionTypes) => {
        if (v.success) {
          //this.DecisionTypes = v.decisionTypes
          this.DecisionTypes = v.decisionTypes.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })

          this.getDecisionRules()

        }
      },
      error: (e) => {

      }
    })
  }
  
  decisionValue: any = []
  rowValues: any = []

  getDecisionTable() {
    return new Promise((resolve, reject) => {
    this.restApi.getDecisionTable().subscribe({
      next: (v: DecisionTable) => {
        if (v.success) {
          this.decisionTable = v.decisionItems.map((item, id) => {
            const decisionRule = this.DecisionRules.find((tempObject: any) => tempObject.id === item.decisionRule);
            const decisionParameter = this.DecisionParameters.find((tempObject: any) => tempObject.id === item.parameterId);
            const decisionType = this.DecisionRules.find((tempObject: any) => tempObject.id === item.decisionType);
            let  bSplitValue = item?.decisionValue.split(',').map(function(item:any) {return parseInt(item, 10); });
            let country =  bSplitValue.map((value:any)=>this.countryList?.dhabiCountries.find((tempObject5: any) => tempObject5?.id === value ))
            let countryNameSeperated = country.map((item5)=>{ return item5?.countryName.toString()})      
            const _selected = this.selectedItems.includes(id);
            // console.log(decisionParameter)
            // console.log(country)
            // console.log(bSplitValue)
            return {
              ...item,
              _selected,
              paramerID: decisionParameter?.name,
              pID: decisionParameter?.id,
              RuleID: decisionRule?.id,
              decisionRule: decisionRule?.description,
              decisionType: decisionType?.description,
              decisionTypeID: decisionType?.id,
              rule: item.decisionRule,
              splitValue: item?.decisionValue,
              decisionValue: decisionParameter?.name != 'Income' ? countryNameSeperated :  item?.decisionValue,
            };
            
          })
          resolve(true);
        }
      },
      error: (e) => {

      }
    })
  })
  }

  submit() {
   console.log(this.decisionTableForm.value?.decisionValue)
    if (this.decisionTableForm.status == "INVALID") {
      this.showAlertBox('Sorry!', 'Source Value should not be Blank!');
      return;
    }
    // if(this.decisionTableForm.value?.decisionValue?.length>5 && this.getRowValueData?.paramerID != 'Income'){
    //   this.showAlertBox('Sorry!', 'Please select only five Country!'); 
    //   return
    // }
   
    else{
       let payload = {
        "decisionItems": [
          {
            "item": this.getRowValueData?.item,
            "parameterId": this.getRowValueData?.parameterId,
            "decisionType":this.getRowValueData?.decisionTypeID,
            "decisionRule":this.getRowValueData?.rule,
            "decisionValue": this.decisionTableForm.value?.decisionValue.toString(),
            "allowOnboarding": this.decisionTableForm.value?.allowOnboarding 
          }
        ]
      }
      //var r = this.decisionTableForm.value.decisionValue.replace(/[(\[].*?[)\]] */g, "");
      this.restApi.updateDecisionTable(payload).subscribe({
        next: (v: UpdateDecisionTable) => {
          if (v.success) {
            console.log(v.success)
            this.decisionSaveModel = false;
            this.goBackToSearchScreen()
          }
        },
        error: (e) => {
  
        }
      })
     

    }
    
  }
  goBackToSearchScreen() {
    this.decisionSaveModel = false;
    this.getDecisionTable()
   
  }
  
  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any
  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) {

  }

  closeAlert(event: any) {
    this.bAlert = event.state
  }

  getCountryNames(selectedCountryIds : number[]) : string {
    let names:string[]=[];
    selectedCountryIds.forEach(countryId => {
      var country = this.countryFullValue.find(item => item.id === countryId);

      if (country?.countryName)
         names.push(country?.countryName);
      });
      
      return names.join(",");
  }
  onChange(event:any){
    this.getRowValueData.decisionValue =  this.getCountryNames(this.decisionTableForm.value?.decisionValue);
  }
  alertVisibility(event: any) {
    this.bAlert = event.state
  }

}
